import { useHistory } from 'react-router-dom';
import { Button, Tooltip, Menu, Dropdown, Typography } from 'antd';
import { blue } from '@ant-design/colors';
import { LogoutOutlined, MenuUnfoldOutlined, MoreOutlined } from '@ant-design/icons';
import styled from 'styled-components';

// resources
import { txt } from '../../locales/i18n';
import { BreadCrumbs } from './bread-crumbs';
import * as AuthService from '../../services/bb-api/auth';
import { socketInstance } from '../shared/socket';

// atoms
import { localesState } from '../../recoil/atoms';
import { useRecoilState } from 'recoil';

// hooks
import { useDeviceSize } from '../../hooks/device-size';

export function AppHeader(props: any): JSX.Element {
	const [locale, setLocale] = useRecoilState(localesState);
	const history = useHistory();
	const isMobileDevice: boolean = useDeviceSize();

	async function handleLogout(): Promise<void> {
		await AuthService.signout();
		socketInstance?.disconnect()
		history.push('/login');
	}

	function handleLocaleChange(value: string): void {
		localStorage.setItem('bb_locale', value);
		setLocale(value);
		window.location.reload();
	}

	function getLocaleItems() {
		const styles: Record<string, any> = {
			da: undefined,
			en: undefined,
		};

		styles[locale] = blue.primary;

		return (
			<Menu>
				<Menu.Item disabled id="version-container">
					<span style={{ fontSize: '0.8rem' }}>{process.env.REACT_APP_VERSION}</span>
				</Menu.Item>

				<Menu.Item>
					<span style={{ color: styles.da }} onClick={() => handleLocaleChange('da')}>
						{txt('global.danish')}
					</span>
				</Menu.Item>

				<Menu.Item>
					<span style={{ color: styles.en }} onClick={() => handleLocaleChange('en')}>
						{txt('global.english')}
					</span>
				</Menu.Item>
			</Menu>
		);
	}

	return (
		<StyledHeader isMobileDevice={isMobileDevice}>
			<Button type="link" onClick={() => props.setOpenMenu((openMenu: boolean) => !openMenu)}>
				<MenuUnfoldOutlined />
			</Button>

			{isMobileDevice === false && <Typography.Text>Boblberg Admin</Typography.Text>}

			<BreadCrumbs className="bread-crumbs" />

			{isMobileDevice === false && (
				<Tooltip title={txt('header.profile tooltip')}>
					<Button
						type="link"
						onClick={() => history.push('/users/' + localStorage.getItem('bb_user_id'))}
					>
						{localStorage.getItem('bb_email')}
					</Button>
				</Tooltip>
			)}

			<Tooltip title={txt('header.logout tooltip')}>
				<Button type="link" onClick={handleLogout}>
					<LogoutOutlined />
				</Button>
			</Tooltip>

			<Dropdown overlay={getLocaleItems()}>
				<Button type="link" className="menu-button">
					<MoreOutlined />
				</Button>
			</Dropdown>
		</StyledHeader>
	);
}

const StyledHeader = styled.header<{ isMobileDevice: boolean }>`
	z-index: 1;
	display: flex;
	align-items: center;
	padding: 0.4em;
	border-top: ${({ isMobileDevice }) => (isMobileDevice ? '1px solid #ddd' : 'none')};
	border-bottom: ${({ isMobileDevice }) => (isMobileDevice ? 'none' : '1px solid #ddd')};

	button {
		font-size: ${({ isMobileDevice }) => (isMobileDevice ? '1rem' : 'auto')};
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bread-crumbs {
		margin-inline: auto;
	}
`;
